import React from 'react';

import Header from '../Components/Dashboard/Header/Header';
import Settings from '../Components/Dashboard/Settings/Settings';


export default function SettingsPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Settings/>
      </div>
    </>
  );
}
